export default {"src":"/_next/static/media/0xc40f949f8a4e094d1b49a23ea9241d289b7b2819.38635f67.svg","height":127,"width":127,"blurWidth":0,"blurHeight":0};